//BlueHandsPriceList.jsx
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import MainLayout from '../../layouts/MainLayout';

const BlueHandsPriceList = () => {

  const pricingData = [
    {
      stakeholder: "Employers (Businesses, Contractors, Companies)",
      plans: [
        { model: "Subscription Plan", details: "Monthly access to job postings, attendance, work history, compliance tools, and analytics.", cost: "₹5,000 - ₹50,000/month ($60 - $600)" },
        { model: "Pay-Per-Job Post", details: "One-time fee per job posting.", cost: "₹500 - ₹2,500/job ($6 - $30)" },
        { model: "Bulk Hiring Package", details: "Hiring package for multiple positions with support.", cost: "₹10,000 - ₹1,00,000/month ($120 - $1,200)" },
        { model: "On-Demand Workforce Management", details: "Advanced workforce tracking, attendance, productivity monitoring.", cost: "₹1,500/worker/month ($18)" }
      ]
    },
    {
      stakeholder: "Aggregators (Master Aggregators & Sub-Aggregators)",
      plans: [
        { model: "Commission-Based Earnings", details: "Earn commission for each worker placed.", cost: "5-10% per successful placement" },
        { model: "Subscription for Advanced Features", details: "Access to premium analytics, priority support.", cost: "₹3,000 - ₹10,000/month ($36 - $120)" },
        { model: "Employer Service Fee", details: "Chargeable to employers for workforce recruitment & management.", cost: "₹1,000 - ₹5,000 per employer ($12 - $60)" }
      ]
    },
    {
      stakeholder: "Workers (Blue Collar Job Seekers)",
      plans: [
        { model: "Freemium Model", details: "Basic access to job postings.", cost: "Free" },
        { model: "Skill Training & Certification", details: "Access to immersive multimedia books, assignments, MCQs, certification tests.", cost: "₹500 - ₹5,000/course ($6 - $60)" },
        { model: "Verified Profile Fee", details: "One-time fee for background verification, increasing job credibility.", cost: "₹500 ($6)" },
        { model: "Premium Job Access", details: "Early access to high-paying job postings.", cost: "₹200 - ₹500/month ($2 - $6)" }
      ]
    },
    {
      stakeholder: "Platform Markup on Aggregators’ Fees",
      plans: [
        { model: "Markup on Aggregator Charges", details: "Platform earns a percentage on Aggregator service fees.", cost: "20-25% per transaction" }
      ]
    }
  ];

  return (
    <MainLayout>
        <div className="mt-12">
          <h2 className="text-3xl font-bold text-center mb-6">BlueHands Platform Pricing Model</h2>
          <div className="space-y-8">
            {pricingData.map((section, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-semibold text-blue-700 mb-4">{section.stakeholder}</h3>
                <div className="overflow-x-auto">
                  <table className="w-full text-left border-collapse border border-gray-200">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="p-3 border border-gray-300">Pricing Model</th>
                        <th className="p-3 border border-gray-300">Details</th>
                        <th className="p-3 border border-gray-300">Estimated Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      {section.plans.map((plan, idx) => (
                        <tr key={idx} className="border border-gray-200">
                          <td className="p-3 border border-gray-300 font-medium text-gray-900">{plan.model}</td>
                          <td className="p-3 border border-gray-300 text-gray-700">{plan.details}</td>
                          <td className="p-3 border border-gray-300 font-semibold text-green-600">{plan.cost}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
      </div>
    </MainLayout>
  )
}

export default BlueHandsPriceList